import { IServiceHistoriesHook } from '@models';
import { useStore } from '@stores';
import { useEffect, useState } from 'react';

export const useServiceHistories = (vin: string): IServiceHistoriesHook => {
  const { serviceHistoryStore } = useStore();
  const {
    serviceHistories,
    totalCount,
    currentPage,
    skipCount,
    maxResultCount,
    loading,
    handlePageChange,
  } = serviceHistoryStore;

  // ABP sorting expression from the table's date column, e.g. 'CreationTime DESC'.
  const [sorting, setSorting] = useState<string | undefined>();

  useEffect(() => {
    return () => {
      serviceHistoryStore.resetServiceHistories();
    };
  }, [serviceHistoryStore]);

  useEffect(() => {
    serviceHistoryStore.getAll({
      vin,
      maxResultCount,
      skipCount,
      sorting,
    });
  }, [serviceHistoryStore, vin, maxResultCount, skipCount, sorting]);

  const handleSortChange = (value?: string) => {
    setSorting(value);
    // Back to page one - a re-ordered list makes the page number meaningless.
    handlePageChange({ current: 1, pageSize: maxResultCount });
  };

  return {
    loading,
    dataSource: Array.from(serviceHistories.values()),
    totalCount,
    skipCount,
    currentPage,
    maxResultCount,
    handlePageChange,
    handleSortChange,
    sorting,
  };
};
